import React, { useEffect, useState } from "react";
import isEmpty from "../../../validations/is-empty";

const JobsSection = ({ result }) => {
  const [searchText, setSearchText] = useState("");
  const [searchedData, setSearchedData] = useState([]);
  const [searchDepartment, setSearchDepartment] = useState("All");

  useEffect(() => {
    if (isEmpty(result)) {
      setSearchedData([]);
    } else {
      setSearchedData(result);
    }
  }, [result]);

  useEffect(() => {
    if (searchDepartment === "All") {
      const filteredData = result.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(searchText.toLowerCase()),
      );

      setSearchedData(filteredData);
    } else {
      const tempData = result.filter(
        (item) => item.department === searchDepartment,
      );

      const filteredData = tempData.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(searchText.toLowerCase()),
      );

      setSearchedData(filteredData);
    }
  }, [searchDepartment, searchText]);

  return (
    <section className="page-section page-section-tight">
      <div className="container">
        <section className="card career-filter-panel">
          <div>
            <p className="eyebrow">Open Positions</p>
            <h2>Find the right fit.</h2>
          </div>
          <label className="field">
            <span className="field-label">Search</span>
            <input
              placeholder="Search title, location, or badge"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </label>
          <label className="field">
            <span className="field-label">Department</span>
            <select onChange={(e) => setSearchDepartment(e.target.value)}>
              <option value="All">All</option>
              <option value="Data Engineering">Data Engineering</option>
              <option value="Software Development">Software Development</option>
              <option value="Product Management">Product Management</option>
              <option value="Quality Assurance (QA)">
                Quality Assurance (QA)
              </option>
              <option value="DevOps/SRE">DevOps/SRE</option>
              <option value="UX/UI Design">UX/UI Design</option>
              <option value="Technical Support/Documentation">
                Technical Support/Documentation
              </option>
            </select>
          </label>
        </section>
        <div className="job-grid">
          {searchedData.map((item, key) => {
            return (
              <article className="card job-card" key={key}>
                <h2>{item.title}</h2>
                <p>{item.summary}</p>
                <div className="badge-row">
                  {item.badges.map((items, keys) => {
                    return (
                      <span className="badge badge-teal" key={keys}>
                        {items}
                      </span>
                    );
                  })}
                </div>
                <a
                  className="button button-primary button-md full-width"
                  href={"/careers/" + item.slug}
                  data-discover="true"
                >
                  View Role
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default JobsSection;
